import { Skeleton, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

import { useUserRewardAccount, useUserRewardAccountHistory } from 'features/rewarding/hooks';
import { LoadingOverlay } from 'shared/components/ui';
import { RewardTransactionsList } from 'shared/features/tracking/components';

import { Container, Content, Header, Section } from './MemberRewardAccountPage.styles';

export function MemberRewardAccountPage() {
  const { id } = useParams<{ id: string }>();

  const {
    data: account,
    isLoading: isAccountLoading,
    isIdle: isAccountIdle,
  } = useUserRewardAccount({ id });

  const {
    data: history,
    isLoading: isHistoryLoading,
    isIdle: isHistoryIdle,
  } = useUserRewardAccountHistory({ id });

  const isLoading = isAccountLoading || isAccountIdle || isHistoryLoading || isHistoryIdle;

  return (
    <Container>
      <Header>
        <Typography variant="h6">Rewards Account</Typography>
      </Header>

      <Content>
        <LoadingOverlay
          loading={isLoading}
          overlay={
            <Skeleton variant="text">
              <Typography variant="h6" color="primary">
                0 points
              </Typography>
            </Skeleton>
          }
        >
          <Typography variant="h6" color="primary">
            {account?.balance} points
          </Typography>
        </LoadingOverlay>

        <Section>
          <RewardTransactionsList history={history} loading={isLoading} />
        </Section>
      </Content>
    </Container>
  );
}
